import batchingFinishFormula from '@/core/components/batchingFinishFormula'
import batchingFinishPrice from '@/core/components/batchingFinishPrice'
import viewEdit from './../components/viewEdit.vue'
import store from '@/store'

export default {
  // 配料成品配方
  className: 'finishProduct',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '型号不可为空'
      ]
    },
    {
      name: 'content',
      // validators: [
      //   (val) => val ? null : '含量不可为空'
      // ]
    },
    {
      name: 'clientid',
      validators: [
        (val) => val ? null : '不可为空'
      ],
      listWhere: (where) => {
        // if (store.state.user.adminRole === 'sale') {
        // where.userid = store.state.user.objectId
        // }
        if (store.state.user && store.state.user.allClient === 'Yes') { } else {
          where.userid = store.state.user.objectId
        }
      },
      // hidden: () => store.state.user && store.state.user.adminRole === 'workshop'
    },
    'describe',
    {
      name: 'price',
      note: '公布价',
      view: {
        component: batchingFinishPrice
      },
      disabled: true
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.isBatching = true
      // where.formula = {
      //   $exists: false
      // }
      where.$or = [
        {
          formula: { $exists: false },
        },
        {
          formula: '[]'
        }
      ]
      if (store.state.user.allShopManagements === 'Yes') { } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
      // if (store.state.user.allClient === 'Yes') {

      // } else {
      //   where.userid = store.state.user.objectId
      // }
      // if (store.state.user.adminRole === 'workshop') {
      // where.workShop = {
      //   $in: store.state.user.shopManagements
      // }
      // }
      // if (store.state.user.adminRole === 'sale') {
      //   where.userid = store.state.user.objectId
      // }
    }
  },
  action: {
    formula: store.state.user && store.state.user.authority.batchingFinishProductUn.formula ? {
      type: 'row',
      text: '修改配方',
      component: batchingFinishFormula
    } : false,
    edit: store.state.user && store.state.user.authority.batchingFinishProductUn.edit // && (store.state.user.adminRole === 'admin' || (store.state.user.adminRole === 'workshop' && store.state.user.operate === 'yes'))
      ? {
        component: viewEdit,
        viewTitle: '编辑配样配方',
        gdData: [
          {
            name: 'model',
            note: '所属型号',
            type: 'Pointer',
            targetClass: 'shopManagement'
          },
          {
            name: 'proportion',
            note: '所属含量',
            type: 'Pointer',
            targetClass: 'shopManagement'
          }
        ]
      } : false,
    delete: store.state.user && store.state.user.authority.batchingFinishProductUn.del ? {
    } : false,
  }
}
